<template>
  <div class="col-span-12">
    <div class="px-5 sm:px-8 py-5 sm:py-10">

      <div class="border-red-600 border-2 p-4 text-red-600 rounded" v-if="activity.type == 'Parejas'">
        Recuerda que el numero de preguntas para la actividad de <b>Parejas</b> debe ser multiplos de 4.
      </div>
      <form @submit.prevent="addQuestionToActivity()" class="intro-y grid grid-cols-12 gap-3 py-0" v-if="!checked && !isShow">
        <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-4">
          <label>Agregar pregunta:</label>
          <input v-model="currentActivityQuestion.title" type="text" class="input w-full border mt-2 flex-1" required>
        </div>
        <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-4">
          <label>Tiempo para respoder (en segundos):</label>
          <input v-model="currentActivityQuestion.time_in_seconds" type="number" class="input w-full border mt-2 flex-1">
        </div>
        <div class="mt-3 col-span-12 sm:col-span-12 md:col-span-4 flex">
          <button type="submit"
            class="button bg-theme-1 text-white mt-auto">
              Agregar Pregunta
          </button>
        </div>
      </form>

      <div class="overflow-x-auto">
        <table class="table">
          <thead>
            <tr class="border-b dark:border-dark-5">
              <th class="whitespace-nowrap text-center">#</th>
              <th class="whitespace-nowrap text-center">PREGUNTA</th>
              <th class="whitespace-nowrap text-center">TIEMPO</th>
              <th class="whitespace-nowrap text-center">ACCIONES</th>
            </tr>
          </thead>
          <tbody v-if="!activityQuestions.length">
            <tr>
              <th colspan="4" class="text-center">No hay Elementos seleccionados</th>
            </tr>
          </tbody>
          <tbody v-for="(item, questionIndex) in activityQuestions"
            :key="`${item.title}-question-item-${questionIndex}`"
            class="border-b dark:border-dark-5">
            <tr class="border">
              <td class="whitespace-nowrap text-center cursor-pointer"
                :class="showCurrentQuestion == questionIndex ? 'text-indigo-600 mobile-menu' : ''"
                @click="showCurrentQuestion = questionIndex">
                No. {{ questionIndex + 1 }}
              </td>
              <td>
                <input v-if="!checked" class="input w-full border mt-2" type="text" v-model.lazy="item.title">
                <div v-else class="font-medium whitespace-nowrap">
                  {{item.title}}
                </div>
              </td>
              <td class="whitespace-nowrap text-center">
                <input v-if="!checked" class="input w-full border mt-2" type="number" v-model.lazy="item.time_in_seconds">
                <div v-else class="font-medium whitespace-nowrap">
                  {{item.time_in_seconds}}
                </div>
              </td>
              <td class="text-right" rowspan="1">
                <button @click="activityQuestions.splice(questionIndex, 1)"
                  type="button"
                  class="button bg-theme-6 text-white mt-auto"
                  v-if="!checked && !isShow">
                  Eliminar Pregunta
                </button>
              </td>
            </tr>
            <tr class="border mb-3">
              <td colspan="4" v-show="showCurrentQuestion == questionIndex">
                <div class="flex flex-col">
                  <h5 class="mx-auto">RESPUESTAS:</h5>
                  <div>
                    <table class="w-full">
                      <thead v-if="item.answers.length">
                        <tr class="border-b dark:border-dark-5">
                          <th class="whitespace-nowrap text-center">Respuesta</th>
                          <th class="whitespace-nowrap text-center">Correcta</th>
                          <th class="whitespace-nowrap text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="border-b">
                        <tr v-for="(answer, index) in item.answers"
                          :key="`answers-key-${index}`">
                          <td>
                            <input class="input w-full border mt-2" type="text" v-model.lazy="answer.text_answer">
                          </td>
                          <td class="flex">
                            <div class="mx-auto">
                              <input type="checkbox"
                                :name="questionIndex"
                                v-model.lazy="answer.correct"
                                :disabled="answer.correct"
                                class="checkbox mt-2 border"
                                @change="checkWhichAnswerChanged(questionIndex, index)">
                              {{ answer.correct ? 'Si' : 'No' }}
                            </div>
                          </td>
                          <td>
                            <div class="flex" v-if="!isShow">
                              <button @click="item.answers.splice(index, 1)"
                                type="button"
                                class="button bg-theme-6 text-white mx-auto">
                                Eliminar Respuesta
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody class="mt-3" v-if="item.answers.length < 4 && activity.type == 'Trivia' || item.answers.length < 1 && activity.type == 'Ordenar Letras'
                        || item.answers.length < 1 && activity.type == 'Parejas'">
                        <tr v-if="!isShow">
                          <td class="text-center">
                            <label>Agregar nueva respuesta:</label>
                          </td>
                          <td class="text-center">
                            <input v-model="currentQuestionAnswer.text_answer"
                              type="text"
                              class="input w-full border mt-2 flex-1">
                          </td>
                          <td>
                            <button @click="addAnswerToQuestion(questionIndex)"
                              type="button"
                              class="button bg-theme-1 text-white mt-auto"
                              :disabled="!currentQuestionAnswer.text_answer">
                              Agregar Respuesta
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            <tr><td></td></tr>
          </tbody>
          <tbody v-if="!isShow">
            <tr>
              <td colspan="4">
                <button @click="updateOrCreateQuestions"
                  class="button bg-theme-1 text-white mt-auto w-auto">
                  Guardar preguntas y respuestas
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'ActivityQuestions',
    props: {
      activity: {
        type: Object,
        default: () => ({})
      },
    },
    beforeMount() {
      this.activityQuestions = JSON.parse(JSON.stringify(this.activity.questions))

      if (this.$route.name == 'show-activity') {
        this.isShow = true
      }
    },
    data() {
      return {
        checked: false,
        currentActivityQuestion: this.defineActivityQuestion(),
        currentQuestionAnswer: this.defineQuestionAnswer(),
        activityQuestions: [],
        showCurrentQuestion: 0,
        isShow: false,
      };
    },
    methods: {
      defineActivityQuestion: () => ({
        title: null,
        time_in_seconds: 30,
        answers: [],
      }),
      defineQuestionAnswer: () => ({
        text_answer: null,
        correct: false,
      }),
      addQuestionToActivity() {
        this.activityQuestions.push(this.currentActivityQuestion)

        this.currentActivityQuestion = this.defineActivityQuestion()
      },
      addAnswerToQuestion(index) {
        let isCorrect = this.activityQuestions[index].answers.length == 0 ? true : false

        this.activityQuestions[index].answers.push({
          text_answer: this.currentQuestionAnswer.text_answer,
          correct: isCorrect,
        });

        this.currentQuestionAnswer.text_answer = "";
      },
      checkWhichAnswerChanged(questionIndex, position) {
        let answers = this.activityQuestions[questionIndex].answers

        answers.forEach((element, index) => {
          element.correct = (index == position) ? true : false
        })
      },
      async updateOrCreateQuestions() {

        const { notValid, message } = this.validateQuestions()

        if (notValid) {
          window.$toast.error(message)
          return
        }

        let data = {
          entity: 'activity',
          questions: this.activityQuestions,
          id: this.activity.slug,
        }

        let form = { ...this.activity, ...data }

        try {
          await this.update(form)
          window.$toast.success('Preguntas y respuestas actualizadas')
          this.$router.push('/admin/activities')
        } catch (error) {
          window.$toast.error(error.message)
        }
      },
      validateQuestions() {

        let response = {
          notValid: false,
          message: '',
        }

        if (this.activityQuestions.length == 0) {
          response.notValid = true
          response.message = 'Debe agregar al menos una pregunta'
          return response
        }

        this.activityQuestions.forEach(question => {

          if (question.title == null || question.title == "") {
            response.notValid = true
            response.message = 'Todas las preguntas deben tener un titulo'
            return response
          }

          if (question.answers.length == 0) {
            response.notValid = true
            response.message = 'Todas las preguntas deben tener al menos una respuesta'
            return response
          }

          question.answers.forEach(answer => {
            if (answer.text_answer == null || answer.text_answer == "") {
              response.notValid = true
              response.message = 'Todas las respuestas deben tener un texto'
              return response
            }
          })
        })

        return response
      },
      ...mapActions([
        'getAll',
        'getList',
        'store',
        'update'
      ])
    },
  };
</script>



// WEBPACK FOOTER //
// ActivityQuestions.vue?5e274a43